import type { TvShowBundleDtoBundleSingleView } from '@bldsoft/cappie/api/wbs'
import type { PurchaseInfo, TvShowBundleInfo } from '@setplex/tria-api'

import { getBackgroundImage, getHorizontalImage } from '../../utils/images'
import { formatPriceSettings } from '../../utils/payment'

export const formatShowBundle = (
  bundle: TvShowBundleDtoBundleSingleView
): TvShowBundleInfo => {
  return {
    id: bundle.id!,
    name: bundle.name!,
    description: bundle.description,
    landscapeImageUrl: getHorizontalImage(bundle.coverImageUrl),
    backgroundImageUrl: getBackgroundImage(bundle.coverImageUrl),
    contentQuantity: bundle.contentQuantity!,
    updatedTime: bundle.updatedTime!,
    tvShowIds: bundle.tvShowIds!,
    seasonIds: bundle.seasonIds!,
    episodeIds: bundle.episodeIds!,
    purchaseInfo: bundle.purchaseInfo as PurchaseInfo,
    priceSettings: formatPriceSettings(bundle.priceSettings) || [],
    free: bundle.priceSettings?.length === 0,
    externalId: bundle.externalId,
  } as TvShowBundleInfo
}
